import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../../styles';

const EnteredIntoPrizeDraw = ({ raceName, prize }) => (
    <>
        <Styled.Heading>You&#39;re in the Prize Draw!</Styled.Heading>
        <Styled.Text>
            Your horse won the {raceName} race. You have now been entered into
            the <Styled.Highlighted>Prize Draw</Styled.Highlighted> to win{' '}
            <Styled.Highlighted>{prize}!</Styled.Highlighted>
        </Styled.Text>
    </>
);

EnteredIntoPrizeDraw.propTypes = {
    raceName: PropTypes.string.isRequired,
    prize: PropTypes.string.isRequired
};

export default EnteredIntoPrizeDraw;
